import { BrowserModule, Title } from '@angular/platform-browser';
import {
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
} from '@angular/core';
import { LoginLayoutComponent } from './Layouts/login-layout.component';
import { PrintLayoutComponent} from './Layouts/print-layout.component';
import { HeaderComponent } from './Components/common/header/header.component';
import {LoginComponent} from './Components/login/login.component';
import {ForgotPasswordComponent} from './Components/forgot-password/forgot-password.component';
import { EntityFormComponent } from './Components/Entity/entity-form/entity-form.component';
import { EntityListComponent } from './Components/Entity/entity-list/entity-list.component';
import {DataService} from './Services/data.service';
import { AppConfigService } from './Services/app-config.service';
import { PermissionsService } from './Services/permissions.service';
import { PreferencesService } from './Services/preferences.service';
import { AppComponent } from './app.component';
import { HomeComponent } from './Components/home/home.component';
import { AppLayoutComponent } from './Layouts/app-layout.component';
import { EntityContactComponent } from './Components/Entity/resources/entity-contact/entity-contact.component';
import { EntityAddressComponent } from './Components/Entity/resources/entity-address/entity-address.component';
import {QuickLinkComponent} from './Components/quick-link/quick-link.component';
import {HomeQuickNavigationComponent} from './Components/home/home-navigation/home-quick-navigation.component';
import {FinancialDashboardComponent} from './Components/financial-dashboard/financial-dashboard.component';
import {ArDashboardComponent} from './Components/ar-dashboard/ar-dashboard.component';
import {ApDashboardComponent} from './Components/ap-dashboard/ap-dashboard.component';
import {CrmDashboardComponent} from './Components/crm/crm-dashboard/crm-dashboard.component';
import {CrmCustomerListComponent} from './Components/crm/crm-customer-list/crm-customer-list.component';
import {CrmCustomerDetailComponent} from './Components/crm/crm-customer-detail/crm-customer-detail.component';
import {CrmPipelineComponent} from './Components/crm/crm-pipeline/crm-pipeline.component';
import {CrmInteractionsComponent} from './Components/crm/crm-interactions/crm-interactions.component';
import {CrmOpportunitiesComponent} from './Components/crm/crm-opportunities/crm-opportunities.component';
import {CrmOpportunityDetailComponent} from './Components/crm/crm-opportunity-detail/crm-opportunity-detail.component';
import {CrmLogInteractionModalComponent} from './Components/crm/crm-log-interaction-modal/crm-log-interaction-modal.component';
import { EntityHistoryComponent } from './Components/Entity/resources/entity-history/entity-history.component';
import { EntityActivityFeedComponent } from './Components/Entity/resources/entity-activity-feed/entity-activity-feed.component';
import { EntityDetailComponent } from './Components/Entity/resources/entity-detail/entity-detail.component';
import { SharedModule } from './Components/common/shared.module';
import { AdminModule } from './Components/admin/admin.module';
import { InventoryModule } from './Components/inventory/inventory.module';
import { AppLocationService } from './Services/appLocation.service';
import { ReportsModule } from './Components/Reports/reports.module';
import { DateFilterService } from './Services/dateFilter.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PasswordResetComponent } from './Components/password-reset/password-reset.component';
import { TransactionsModule } from './Components/transactions/transactions.module';
import { WorkOrdersListComponent } from './Components/work-orders/work-orders-list/work-orders-list.component';
import { WorkOrdersFormComponent } from './Components/work-orders/work-orders-form/work-orders-form.component';
import {WorkOrdersBillingComponent} from './Components/work-orders/work-orders-billing/work-orders-billing.component';
import {WorkOrdersDashboardComponent} from './Components/work-orders/work-orders-dashboard/work-orders-dashboard.component';
import {WorkOrdersScheduleComponent} from './Components/work-orders/work-orders-schedule/work-orders-schedule.component';
import {WoHoursTabComponent} from './Components/work-orders/tabs/wo-hours-tab/wo-hours-tab.component';
import {WoTravelTabComponent} from './Components/work-orders/tabs/wo-travel-tab/wo-travel-tab.component';
import {WoItemsTabComponent} from './Components/work-orders/tabs/wo-items-tab/wo-items-tab.component';
import {WoNotesTabComponent} from './Components/work-orders/tabs/wo-notes-tab/wo-notes-tab.component';
import {WoAttachmentsTabComponent} from './Components/work-orders/tabs/wo-attachments-tab/wo-attachments-tab.component';
import {WoNotificationsTabComponent} from './Components/work-orders/tabs/wo-notifications-tab/wo-notifications-tab.component';
import {WoChecklistTabComponent} from './Components/work-orders/tabs/wo-checklist-tab/wo-checklist-tab.component';
import {AssetListComponent} from './Components/work-orders/assets/asset-list/asset-list.component';
import {AssetFormComponent} from './Components/work-orders/assets/asset-form/asset-form.component';
import {AssetDetailComponent} from './Components/work-orders/assets/asset-detail/asset-detail.component';
import {PmScheduleListComponent} from './Components/work-orders/pm-schedules/pm-schedule-list/pm-schedule-list.component';
import {PmScheduleFormComponent} from './Components/work-orders/pm-schedules/pm-schedule-form/pm-schedule-form.component';
import {WoTypeListComponent} from './Components/work-orders/settings/wo-type-list/wo-type-list.component';
import {WoCategoryListComponent} from './Components/work-orders/settings/wo-category-list/wo-category-list.component';
import {
  WoUserBillingRateListComponent
} from './Components/work-orders/settings/wo-user-billing-rate-list/wo-user-billing-rate-list.component';
import {ChecklistTemplateListComponent} from './Components/work-orders/settings/checklist-template-list/checklist-template-list.component';
import { TimesheetFormComponent } from './Components/timesheet/timesheet-form/timesheet-form.component';
import { TimesheetListComponent } from './Components/timesheet/timesheet-list/timesheet-list.component';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { ConfirmDialogService } from './Services/confirm-dialog.service';
import {OnboardComponent} from './Components/onboard/onboard.component';
import { EmployeeListComponent } from './Components/payroll/employee-list/employee-list.component';
import { EmployeeFormComponent } from './Components/payroll/employee-form/employee-form.component';
import {CustomFilterPipe} from './Components/common/custom-filter.pipe';
import { ModalSelectEmployeeComponent } from './Components/payroll/modal-select-employee/modal-select-employee.component';
import { PayrollPaymentPrintComponent } from './Components/payroll/payroll-payment-print/payroll-payment-print.component';
import {DepartmentListComponent} from './Components/payroll/department-list/department-list.component';
import {DepartmentFormComponent} from './Components/payroll/department-form/department-form.component';
import {EmployeeTypeListComponent} from './Components/payroll/employee-type-list/employee-type-list.component';
import {EmployeeTypeFormComponent} from './Components/payroll/employee-type-form/employee-type-form.component';
import {ProviderConfigComponent} from './Components/payroll/provider-config/provider-config.component';
import {GustoDashboardComponent} from './Components/payroll/gusto-dashboard/gusto-dashboard.component';
import {StripeDashboardComponent} from './Components/stripe-dashboard/stripe-dashboard.component';
import {TimeEntryFormComponent} from './Components/timesheet/time-entry-form/time-entry-form.component';
import {TimesheetApprovalListComponent} from './Components/timesheet/timesheet-approval-list/timesheet-approval-list.component';
import {TimesheetApprovalFormComponent} from './Components/timesheet/timesheet-approval-form/timesheet-approval-form.component';

import {DelinquentReceivablesComponent} from './Components/delinquent-receivables/delinquent-receivables.component';

// pos browser
import { PosDataBrowserListComponent } from './Components/pos/pos-data-browser-list/pos-data-browser-list.component';
import {DelinquentPayablesComponent} from './Components/delinquent-payables/delinquent-payables.component';


// modules to share data across components

// encryption
import { EncrDecrService } from './Services/encr-decr.service';

// error interceptor
import {HttpInterceptorService} from './Interceptors/http-interceptor.service';
import {JwtInterceptorService} from './Interceptors/jwt-interceptor.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { TransactionLayoutComponent } from './Layouts/transaction-layout.component';
import {
  NgbAlertModule,
  NgbCollapseModule,
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDropdownModule,
  NgbPaginationModule
} from '@ng-bootstrap/ng-bootstrap';
import {
  ReportDatepickerAdapter,
  ReportDatepickerFormatService,
  ReportDatepickerParserFormatter
} from './Components/common/ngb-datepicker/ngb-datepicker-adapter';
import {FormsModule} from '@angular/forms';
import { SimplebarAngularModule } from 'simplebar-angular';

// widgets

import { WidgetModule } from './Components/common/widget/widget.module';

import { VerifyEmailComponent } from './Components/verify-email/verify-email.component';


import {SideMenuComponent} from './Components/side-menu/side-menu.component';
import {NgApexchartsModule} from 'ng-apexcharts';
// fixed assets
import {FixedAssetListComponent} from './Components/fixed-assets/fixed-asset-list/fixed-asset-list.component';
import {FixedAssetFormComponent} from './Components/fixed-assets/fixed-asset-form/fixed-asset-form.component';

// route reuse
import {RouteReuseStrategy} from '@angular/router';
import {CustomRouteReuseStrategy} from './app-reuse-strategy';

import {ComponentsModule} from './Components/components.module';
import {CalendarModule} from './Components/calendar/calendar.module';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {ChatThreadComponent} from './Components/common/chat/chat-thread/chat-thread.component';

// project management
import {ProjectDashboardComponent} from './Components/projects/project-dashboard/project-dashboard.component';
import {ProjectListComponent} from './Components/projects/project-list/project-list.component';
import {ProjectFormComponent} from './Components/projects/project-form/project-form.component';
import {ProjectDetailComponent} from './Components/projects/project-detail/project-detail.component';
import {PmUserBillingRateListComponent} from './Components/projects/settings/pm-user-billing-rate-list/pm-user-billing-rate-list.component';

// stripe stuff
import {NgxStripeModule} from 'ngx-stripe';

@NgModule({
  declarations: [
    AppComponent,
    LoginLayoutComponent,
    ForgotPasswordComponent,
    AppLayoutComponent,
    PrintLayoutComponent,
    LoginComponent,
    HeaderComponent,

    EntityListComponent,
    EntityFormComponent,
    EntityHistoryComponent,
    EntityActivityFeedComponent,
    EntityDetailComponent,

    HomeComponent,

    EntityContactComponent,
    EntityAddressComponent,

    QuickLinkComponent,
    HomeQuickNavigationComponent,
    FinancialDashboardComponent,
    ArDashboardComponent,
    ApDashboardComponent,
    CrmDashboardComponent,
    CrmCustomerListComponent,
    CrmCustomerDetailComponent,
    CrmPipelineComponent,
    CrmInteractionsComponent,
    CrmOpportunitiesComponent,
    CrmOpportunityDetailComponent,
    CrmLogInteractionModalComponent,
    PasswordResetComponent,
    WorkOrdersListComponent,
    WorkOrdersFormComponent,
    WorkOrdersBillingComponent,
    WorkOrdersDashboardComponent,
    WorkOrdersScheduleComponent,
    WoHoursTabComponent,
    WoTravelTabComponent,
    WoItemsTabComponent,
    WoNotesTabComponent,
    WoAttachmentsTabComponent,
    WoNotificationsTabComponent,
    WoChecklistTabComponent,
    AssetListComponent,
    AssetFormComponent,
    AssetDetailComponent,
    PmScheduleListComponent,
    PmScheduleFormComponent,
    WoTypeListComponent,
    WoCategoryListComponent,
    WoUserBillingRateListComponent,
    PmUserBillingRateListComponent,
    ChecklistTemplateListComponent,
    TimesheetFormComponent,
    TimesheetListComponent,
    TimeEntryFormComponent,
    TimesheetApprovalListComponent,
    TimesheetApprovalFormComponent,
    OnboardComponent,
    EmployeeListComponent,
    EmployeeFormComponent,
    DepartmentListComponent,
    DepartmentFormComponent,
    EmployeeTypeListComponent,
    EmployeeTypeFormComponent,
    ProviderConfigComponent,
    GustoDashboardComponent,
    StripeDashboardComponent,
    ModalSelectEmployeeComponent,
    PayrollPaymentPrintComponent,
    DelinquentReceivablesComponent,
    PosDataBrowserListComponent,
    DelinquentPayablesComponent,
    TransactionLayoutComponent,
    VerifyEmailComponent,
    SideMenuComponent,
    // fixed assets
    FixedAssetListComponent,
    FixedAssetFormComponent,
    ChatThreadComponent,
    // project management
    ProjectDashboardComponent,
    ProjectListComponent,
    ProjectFormComponent,
    ProjectDetailComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    NgxStripeModule.forRoot('pk_test_51TJxpqKcYX3NB0Km2lBFds2N0ynPRp30nUTTKqOaDyWwFCBdu9hlDBrzb1xJ0UnV9cpTPlfY64dg4k9r4iZKjpNc00XD221MVq'),
    SharedModule,
    AdminModule,
    ReportsModule,
    InventoryModule,
    // PayrollModule,
    BrowserAnimationsModule,
    TransactionsModule,
    FilterPipeModule,
    WidgetModule,
    CalendarModule,
    NgbCollapseModule,
    SimplebarAngularModule,
    NgbDropdownModule,
    NgbPaginationModule,
    NgApexchartsModule,
    ComponentsModule,
    DragDropModule,
  ],
  providers: [
    DataService,
    Title,
    AppConfigService,
    PreferencesService,
    PermissionsService,
    AppLayoutComponent,
    LoginLayoutComponent,
    PrintLayoutComponent,
    DateFilterService,
    AppLocationService,
    ConfirmDialogService,
    // for shared data
    // end
    // encryption
    EncrDecrService,
    // end
    // UnsavedChangesService,
    CustomFilterPipe,
    ReportDatepickerFormatService,
    {provide: NgbDateAdapter, useClass: ReportDatepickerAdapter},
    {provide: NgbDateParserFormatter, useClass: ReportDatepickerParserFormatter},
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [AppConfigService],
      useFactory: (appConfigService: AppConfigService) => {
        return () => {
          return appConfigService.loadAppConfig();
        };
      },
    },
    // Removed IndexedDB persistence for Fixed Assets (mock data hydration).
    // If needed for local dev, reintroduce behind an environment flag.
    {
      provide: RouteReuseStrategy,
      useClass: CustomRouteReuseStrategy
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    PasswordResetComponent,
    // UnsavedChangesComponent,
    // UnsavedChangesDirective,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
